<template>
  <v-layout align-center justify-center column fill-height>
    <v-progress-circular
      size="60"
      width="2"
      color="primary"
      indeterminate
      v-if="starting"
    ></v-progress-circular>
    <template v-else>
      <v-card
        :min-width="getWidth()"
        class="rounded-lg mr-4 ml-4 pa-2 mb-3"
        flat
        v-if="usersRelac.length > 0 && !selecionouUser"
      >
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="(usr, i) in usersRelac"
              :key="i"
              class="grey lighten-4 rounded-md mt-2"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold body-1">{{
                  usr.usuariologin
                }}</v-list-item-title>
                <v-list-item-subtitle class="subtitle-1">{{
                  usr.descrepresentante
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  small
                  rounded
                  depressed
                  icon
                  color="success"
                  @click="selecionarUsuario(usr)"
                  title="Entrar"
                  large
                  ><v-icon>mdi-arrow-right</v-icon></v-btn
                >
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-btn
            rounded
            block
            depressed
            class="mt-4"
            color="info"
            height="32"
            @click="usersRelac = []"
          >
            Outro usuário</v-btn
          >
        </v-card-text>
      </v-card>
      <v-card
        :min-width="getWidth()"
        class="rounded-lg mr-4 ml-4 pa-2"
        flat
        v-else-if="usersRelac.length == 0 || selecionouUser"
      >
        <v-card-title class="font-weight-bold">Área de acesso</v-card-title>
        <v-card-text class="">
          <v-form ref="form">
            <v-text-field
              prepend-icon="mdi-account-outline"
              label="Usuário"
              v-model="dadosLogin.usuario"
              :rules="[(v) => !!v || 'Informe o usuário']"
              autofocus
              :disabled="selecionouUser"
              autocomplete="username"
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-lock-outline"
              label="Senha"
              :type="visualizarSenha ? 'text' : 'password'"
              v-model="dadosLogin.senha"
              :rules="[(v) => !!v || 'Informe a senha']"
              :append-icon="visualizarSenha ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="visualizarSenha = !visualizarSenha"
              :autofocus="selecionouUser"
              autocomplete="current-password"
              @keyup.enter="entrar()"
            ></v-text-field>

            <v-btn
              rounded
              depressed
              block
              color="success"
              class="mt-3"
              @click="entrar()"
              :loading="loading"
              >Entrar</v-btn
            >

            <recuperar-senha />
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import RecuperarSenha from "../../components/login/RecuperarSenha.vue";
import { salvarUsuariosRelacionados, getUsuarios } from "@/db/usuario";

export default {
  computed: {
    ...mapState("usuario", ["dadosLogin"]),
  },
  components: {
    RecuperarSenha,
  },
  data: () => ({
    loading: false,
    msgErro: "",
    erro: false,
    visualizarSenha: false,
    usersRelac: [],
    selecionouUser: false,
    starting: true,
  }),
  methods: {
    ...mapActions("usuario", ["login"]),
    ...mapActions("pedidos", ["getProdutos"]),
    getWidth() {
      return this.$mq != "sm" ? 400 : 0;
    },
    async entrar() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.login()
          .then(async (res) => {
            if (res.data.success) {
              localStorage.setItem(
                "nutricao-animal-usuario-token",
                res.data.data[0].token
              );
              await salvarUsuariosRelacionados(res.data.data);
              this.$router.push({ path: "/" });
            } else {
              this.$toasted.error(res.data.msg);
            }
          })
          .catch((e) => {
            this.$toasted.error(e);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    selecionarUsuario(value) {
      this.dadosLogin.usuario = value.usuariologin;
      this.selecionouUser = true;
    },
  },
  async mounted() {
    this.starting = true;
    var users = await getUsuarios();
    users.forEach((u) => {
      var usrJaAdd =
        this.usersRelac.findIndex((ur) => ur.usuariologin == u.usuariologin) >=
        0;

      if (!usrJaAdd) this.usersRelac.push(u);
    });
    this.starting = false;
  },
};
</script>

<style>
</style>